module.exports = __webpack_public_path__ + "img/tf.2e7dc1af.svg";